import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(dashboard)/assessments/$assessmentId')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
